import type React from "react";
import {
	ContentContainer,
	ContentContainerWrapper,
} from "~/components/ContentContainer";
import { DefaultLayout } from "~/components/Layout";
import { SimpleResult } from "~/components/SimpleResult";

export const CompleteDeleteAccount: React.FC = () => {
	return (
		<>
			<title>Verify | TIER IV Account | TIER IV Account</title>
			<DefaultLayout>
				<ContentContainerWrapper>
					<ContentContainer size="lg">
						<h1 className="mt-10 text-center font-normal">
							DELETE YOUR ACCOUNT
						</h1>
						<SimpleResult type="info">
							Thank you for using TIER IV Account !
						</SimpleResult>
						<p className="text-center">
							<a
								href="/login"
								className="btn btn-lg btn-t4-border rounded-full"
							>
								CLOSE
							</a>
						</p>
					</ContentContainer>
				</ContentContainerWrapper>
			</DefaultLayout>
		</>
	);
};
